export const environment = {
  production: true,
  api: {
    root: 'https://idep-backoffice-acc.azurewebsites.net',
  },
};
